export const NOTIFICATION_TIMEOUT = 4000;
export const MILISECONDS = 1000;
export const SECONDS_PER_MINUTE = 60;
export const DECIMALS = 2;
export const DEBOUNCE_TIME = 600;
export const WAIT_TIME_100 = 100;
export const FIRST_PAGE = 1;
export const MIN_PER_PAGE = 5;
export const DEFAULT_PER_PAGE = 10;
export const ERROR_CODE_404 = 404;
export const ERROR_CODE_412 = 412;
export const CODE_200 = 200;
export const MAX_PER_PAGE = 100;
export const METAFIELD_CLASS = {
  FORM: "Form",
  ITEM: "Item"
};
export const FORM_STATUS = {
  CLOSED: "CLOSED",
  OPEN: "OPEN"
};
// Cart statuses where the cart is still editable and not yet checked out.
// Other statuses (CheckedOut, PendingPayment) represent a cart in the
// checkout/payment flow.
export const CART_OPEN_STATUSES = ["New", "Open"];
export const PURCHASE_STATUS = {
  PENDING: "Pending",
  PAID: "Paid",
  CANCELLED: "Canceled"
};
export const PURCHASE_METHODS = {
  INVOICE: "Invoice"
};
// status of a purchase's active payment
export const PAYMENT_STATUS = {
  NEW: "New",
  PENDING: "Pending",
  ERROR: "Error",
  CONFIRMED: "Confirmed"
};
export const PROMISE_BATCH_LIMIT = 5;
export const DATE_FORMAT = "MM/DD/YYYY";
export const DATETIME_FORMAT = "MM/DD/YYYY hh:mm a";

export const FILE_UPLOAD_STATUS = {
  PENDING: "PENDING",
  DEADLINE_ALERT: "DEADLINE ALERT",
  DEADLINE_MISSED: "DEADLINE MISSED",
  COMPLETE: "COMPLETE"
};
// eslint-disable-next-line no-magic-numbers
export const DEFAULT_DEADLINE_TOLERANCE_SECONDS = 3 * 60 * 60 * 24; // 3 days
export const PAGE_MODULE_KIND = {
  INFO: "Info",
  DOCUMENT: "Document",
  MEDIA: "Media"
};
export const PAGE_MODULE_MEDIA_TYPE = {
  FILE: "File",
  INPUT: "Input"
};
export const MAX_PAGE_MODULE_UPLOAD_QTY = 1;

export const SPONSOR_BADGE_SCAN_ALLOWED_GROUPS = [
  "sponsors",
  "sponsors-external-users"
];

export const STRIPE_PAYMENT_INTENT_STATUS = {
  SUCCEEDED: "succeeded",
  PROCESSING: "processing"
};

export const STRIPE_ERROR_TYPES = {
  VALIDATION_ERROR: "validation_error",
  CARD_ERROR: "card_error"
};

export const IDP_CONFIG_STATUS = {
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error"
};

export const ONE_MB_DJS_CONFIG = 1000000;

export const FIVE = 5;
export const TWO = 2;

export const UPLOAD_PROFILES = {
  SLOW: {
    name: "SLOW",
    chunkSize: TWO * ONE_MB_DJS_CONFIG,
    maxConcurrentChunks: 3
  },
  FAST: {
    name: "FAST",
    chunkSize: FIVE * ONE_MB_DJS_CONFIG,
    maxConcurrentChunks: 4
  }
};
